import { SQLAgentResponse, v2 } from "@pufflig/prompt-studio-types";
import { shortUID } from "@pufflig/prompt-tools";
import { PromptbookWebRuntime } from "@pufflig/promptbook-runtime";
import { finishThread, getThreadParams, getThreadValue, hasThread, setThreadValue } from "./threads/threads";

/**
 * Handles the response from the SQL agent.
 *
 * @param event
 * @returns
 */
export const handleSQLAgentResponse = async (parsedData: SQLAgentResponse, runtime: PromptbookWebRuntime) => {
  const threadId = parsedData.threadId;

  if (parsedData.type !== "sql_agent_response" || !hasThread(threadId)) return;

  const params = getThreadParams(threadId);
  const resultName = params.resultName || "";

  try {
    if (parsedData.sql) {
      setThreadValue(threadId, "sql", parsedData.sql);
      setThreadValue(threadId, "dialect", parsedData.dialect);
    }

    if (parsedData.data) {
      setThreadValue(threadId, "table", parsedData.data);
    }

    if (parsedData.error) {
      finishThread(threadId, `${parsedData.error}`, true);
    }

    if (parsedData.isDone) {
      const resultId = shortUID();
      const table = getThreadValue(threadId, "table") || [];

      const { success: tableSchema } = await runtime.db.describeArray(resultId, table);

      const result: v2.TableResult = {
        code: {
          content: getThreadValue(threadId, "sql") || "",
          language: getThreadValue(threadId, "dialect") || "sql",
        },
        tableSchema: tableSchema || { columns: [], tableName: resultId },
        metadata: {
          createdAt: new Date().toISOString(),
          resultId,
          resultName: resultName,
          resultType: "table",
        },
        table,
      };

      finishThread(threadId, result);
    }
  } catch (err) {
    finishThread(threadId, `Error parsing WebSocket message: ${err}`, true);
  }
};
